module.exports = __webpack_public_path__ + "static/media/toyota_logo.bf8acf53.png";